import React, {useState, useEffect} from 'react';
import {FormControl,Grid,Button,InputLabel, MenuItem, TextField,Select, Box} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';
import qs from 'qs';
import Modal from '../generales/Modal';

const useStyles = makeStyles((theme) => ({
    root: {
      margin: {
        margin: theme.spacing(1),
      },
    },
    formEncabezado:{
      marginTop:'1.7em',  
    },
    formAnotacion: {
      width:'28.5em'
    },
    formSelect: {
      width:'8em'
    },
    formSelectTipo: {
        width:'150px'
    },
    formSelectElemento:{
        width:'200px'
    },
    formSelectUnidad:{
        width:'180px'
    },
    formObs:{
        marginTop:'1.7em',
        width:'30em',
        height:'6em'
    },
  }));


export default function NuevaAlerta({modalAbierto,setModalAbierto,titulo}){
    const classes = useStyles();
    const source = axios.CancelToken.source();    
    const [listaElementos, setListaElementos] = useState([])
    const [listaCategoria, setListaCategoria] = useState([])
    const [listaTipo, setListaTipo] = useState([])
    const [listaUnidad, setListaUnidad] = useState([])
    const [listaStatus, setListaStatus] = useState([])
    const [espera, setEspera] = useState(false)
    const [aviso, setAviso] = useState(false);
    const [mensaje, setMensaje] = useState("");
    const [tipoAdvertencia, setTipoAdvertencia] = useState("success");
    const [btnDeshabilitado,setBtnDeshabilitado]= useState(false)
    const [registro, setRegistro] = useState({
                                                  Tipo: 0,
                                                  Status:0,
                                                  Categoria: 0,
                                                  Unidad: 0,
                                                  Elemento: 0,
                                                  Lat: 19.599229,
                                                  Lon: -98.904685,
                                                  Direcc: "",
                                                  Descr: "",
                                                  Observ: "",
                                                  })
    const {Tipo,Status,Categoria,Unidad,Elemento,Lat,Lon,Direcc,Descr,Observ} = registro
    const exPermitidaAlfaNumerica = /^([A-Za-z0-9áéíóúÁÉÍÓÚñÑ]+)(?:[A-Za-z0-9 _.,ñÑáéíóúÁÉÍÓÚ]*)$/

    useEffect(()=>{
        
        async function getStatus(){
            let auxU=process.env.REACT_APP_LINKTEZO +`/alerta-status`;   
            let dataInfo = qs.stringify({     
                'usuario':1,   
                'idDispositivo':'w845sdc15ds3dc1s'
                });
                let config = {
                    url:auxU ,
                    method: 'POST',
                    headers: {'Content-Type': 'application/x-www-form-urlencoded' },
                    data: dataInfo,
                    cancelToken: source.token
                };
                let aux ={};           
                await axios(config)
                .then(function (response) {          
                    aux=  response.data;    
                    if(aux[0].Id>-1){
                        setListaStatus(aux)
                    }
                }).catch(function (error) {          
                    console.log(`Error: ${error}`);        
                    if( error && error.response && error.response.data && error.response.data.mensaje==="Datos Incorrectos")
                    {
                      console.log('datos incorrectos' );  
                    }
                })
        }
        async function getTipoAlerta(){
            let auxU=process.env.REACT_APP_LINKTEZO +`/alerta-tipo`;   
            let dataInfo = qs.stringify({     
                'usuario':1,   
                'idDispositivo':'w845sdc15ds3dc1s'
                });
                let config = {
                    url:auxU ,
                    method: 'POST',
                    headers: {'Content-Type': 'application/x-www-form-urlencoded' },
                    data: dataInfo,
                    cancelToken: source.token
                };
                let aux ={};           
                await axios(config)
                .then(function (response) {          
                    aux=  response.data;    
                    if(aux[0].Id>-1){
                        
                        setListaTipo(aux)
                    }
                }).catch(function (error) {          
                    console.log(`Error: ${error}`);        
                    if( error && error.response && error.response.data && error.response.data.mensaje==="Datos Incorrectos")
                    {
                      console.log('datos incorrectos' );  
                    }
                })
        }

        async function getListaCategoria(){
            let auxU=process.env.REACT_APP_LINKTEZO +`/alerta-categoria`;   
            let dataInfo = qs.stringify({     
                'usuario':1,   
                'idDispositivo':'w845sdc15ds3dc1s'
                });
                let config = {
                    url:auxU ,
                    method: 'POST',
                    headers: {'Content-Type': 'application/x-www-form-urlencoded' },
                    data: dataInfo,
                    cancelToken: source.token
                };
                let aux ={};           
                await axios(config)
                .then(function (response) {          
                    aux=  response.data;    
                    if(aux[0].Id>-1){
                        setListaCategoria(aux)
                    }
                }).catch(function (error) {          
                    console.log(`Error: ${error}`);        
                    if( error && error.response && error.response.data && error.response.data.mensaje==="Datos Incorrectos")
                    {
                      console.log('datos incorrectos' );  
                    }
                })
        }

        async function getListaUnidad(){
            let auxU=process.env.REACT_APP_LINKTEZO +`/seguridad-unidad-list`;   
            let dataInfo = qs.stringify({     
                'usuario':1,   
                'idDispositivo':'w845sdc15ds3dc1s'
                });
                let config = {
                    url:auxU ,
                    method: 'POST',
                    headers: {'Content-Type': 'application/x-www-form-urlencoded' },
                    data: dataInfo,
                    cancelToken: source.token
                };
                let aux ={};           
                await axios(config)
                .then(function (response) {          
                    aux=  response.data;    
                    if(aux[0].Id>-1){
                        aux.sort(function (a, b) { return a.Id - b.Id; });   
                        setListaUnidad(aux)
                    }
                }).catch(function (error) {          
                    console.log(`Error: ${error}`);        
                    if( error && error.response && error.response.data && error.response.data.mensaje==="Datos Incorrectos")
                    {
                      console.log('datos incorrectos' );  
                    }
                })
        }

        async function getElementos(){
            let auxU=process.env.REACT_APP_LINKTEZO +`/seguridad-elemento-list`;   
            let dataInfo = qs.stringify({     
                'usuario':1,   
                'idDispositivo':'w845sdc15ds3dc1s'
                });
                let config = {
                    url:auxU ,
                    method: 'POST',
                    headers: {'Content-Type': 'application/x-www-form-urlencoded' },
                    data: dataInfo,
                    cancelToken: source.token
                };
                let aux ={};           
                await axios(config)
                .then(function (response) {          
                    aux=  response.data;    
                    if(aux[0].Id>-1){
                        aux.sort(function (a, b) { return a.Id - b.Id; });   
                        setListaElementos(aux)
                    }
                }).catch(function (error) {          
                    console.log(`Error: ${error}`);        
                    if( error && error.response && error.response.data && error.response.data.mensaje==="Datos Incorrectos")
                    {
                      console.log('datos incorrectos' );  
                    }
                })
        }
        getStatus()
        getTipoAlerta()
        getListaCategoria()
        getListaUnidad()
        getElementos()
    },[]);


    function onChangeTipo(e){
        setRegistro({
            ...registro,
            Tipo: e.target.value
        })
    }

    function onChangeCategoria(e){
        setRegistro({
            ...registro,
            Categoria: e.target.value
        })
    }

    function onChangeStatus(e){
        setRegistro({
            ...registro,
            Status: e.target.value
        })
    }


    function onChangeUnidad(e){
        setRegistro({
            ...registro,
            Unidad: e.target.value
        })
    }

    function onChangeElemento(e){
        setRegistro({
            ...registro,
            Elemento: e.target.value
        })
    }

    function onChangeDireccion(e){
        if(exPermitidaAlfaNumerica.test(e.target.value)||e.target.value===' '||e.target.value===''){
            setRegistro({
                ...registro,
                Direcc: e.target.value
            })
        }
    }

    function onChangeDescripcion(e){
        if(exPermitidaAlfaNumerica.test(e.target.value)||e.target.value===' '||e.target.value===''){
            setRegistro({
                ...registro,
                Descr: e.target.value
            })
        }
    }
    function onChangeObservacion(e){
        if(exPermitidaAlfaNumerica.test(e.target.value)||e.target.value===' '||e.target.value===''){
            setRegistro({
                ...registro,
                Observ: e.target.value
            })
        }
    }

    function verificarTipo(tp){
        let validado=false;
        if(parseInt(tp)!==0){
            validado=true
        }else{
            setTipoAdvertencia("warning")
            setMensaje("Seleccione un tipo válido")
            setAviso(true)
            validado=false;
        }
        return validado;
    }

    function verificarCategoria(cat){
        let validado=false;
        if(parseInt(cat)!==0){
            validado=true
        }else{
            setTipoAdvertencia("warning")
            setMensaje("Seleccione una categoría válida")
            setAviso(true)
            validado=false;
        }
        return validado;
    }

    function verificarStatus(stat){
        let validado=false;
        if(parseInt(stat)!==0){
            validado=true
        }else{
            setTipoAdvertencia("warning")
            setMensaje("Seleccione un status válido")
            setAviso(true)
            validado=false;
        }
        return validado;
    }

    function verificarUnidad(uni){
        let validado=false;
        if(parseInt(uni)!==0){
            validado=true
        }else{
            setTipoAdvertencia("warning")
            setMensaje("Seleccione una unidad válida")
            setAviso(true)
            validado=false;
        }
        return validado;
    }

    function verificarElemento(ele){
        let validado=false;
        if(parseInt(ele)!==0){
            validado=true
        }else{
            setTipoAdvertencia("warning")
            setMensaje("Seleccione un elemento válido")
            setAviso(true)
            validado=false;
        }
        return validado;
    }

    function verificarObservacion(ob){
        let validado=false;
        if(ob && ob!==" "){
            validado=true
        }else{
            setTipoAdvertencia("warning")
            setMensaje("Ingrese Observación")
            setAviso(true)
            validado=false;
        }
        return validado;
    }

    function verificarDirección(dir){
        let validado=false;
        if(dir && dir!==" "){
            validado=true
        }else{
            setTipoAdvertencia("warning")
            setMensaje("Ingrese Dirección")
            setAviso(true)
            validado=false;
        }
        return validado;
    }

    function handleSubmition(){
        if(verificarTipo(Tipo)&&verificarCategoria(Categoria)&&verificarUnidad(Unidad)&&verificarStatus(Status)
            &&verificarElemento(Elemento)&&verificarDirección(Direcc)&&verificarObservacion(Observ)){
                registrarAlerta()
        }
    }

   async function registrarAlerta(){
        setEspera(true);
        setBtnDeshabilitado(true);

        let auxU=process.env.REACT_APP_LINKTEZO +`/alerta-nuevo`;   
            let dataInfo = qs.stringify({     
                'Usuario':1,   
                'Usrsystem':1,
                'Tipo':Tipo,
                'Status': Status,
                'Categoria':Categoria,
                'Unidad':Unidad,
                'Elemento': Elemento,
                'Lat': Lat,
                'Lon':Lon,
                'Direccion':Direcc,
                'Descripcion':Descr,
                'Observacion':Observ,
                'Motivocancel':'',
                'idDispositivo':'542d1sc12dsc'
                });
                let config = {
                    url:auxU ,
                    method: 'POST',
                    headers: {'Content-Type': 'application/x-www-form-urlencoded' },
                    data: dataInfo,
                    cancelToken: source.token
                };
                let aux ={};           
                await axios(config)
                .then(function (response) {          
                    aux=  response.data;    
                    if(aux.respuesta===1){
                        
                        setTipoAdvertencia("success")
                        setMensaje("Alerta agregada con éxito")
                        setAviso(true)
                    }
                }).catch(function (error) {          
                    console.log(`Error: ${error}`);        
                    if( error && error.response && error.response.data && error.response.data.mensaje==="Datos Incorrectos")
                    {
                      console.log('datos incorrectos' );  
                    }
                })
        setEspera(false)

    }


    return (
        <Modal
        titulo={titulo}
        modalAbierto={modalAbierto}
        setModalAbierto={setModalAbierto}
        guardarDatos={handleSubmition}
        mensaje={mensaje}
        tipoAdvertencia={tipoAdvertencia}
        aviso={aviso}
        btnDeshabilitado={btnDeshabilitado}
        setAviso={setAviso}
        tamanio={'l'}
        cargando={espera}>
            <form className={classes.root} noValidate autoComplete="off"> 
            <Grid container spacing={1}>
                {listaTipo.length!=0 ? 
                <Grid item sx={6}>
                <FormControl className={classes.formSelectTipo}>
                    <InputLabel id="Tipo">Tipo</InputLabel>
                    <Select
                      label="Tipo" id="Tipo" name="Tipo"
                      value={Tipo} onChange={onChangeTipo}
                    >
                      {listaTipo.map((tp, index) => (
                        <MenuItem value={tp.Id} key={tp.Id}>
                          <em>{tp.Nom}</em>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid> :null
                }
                {listaCategoria.length!=0 ? 
                <Grid item sx={1}>
                <FormControl className={classes.formSelect}>
                    <InputLabel id="Categoria">Categoría</InputLabel>
                    <Select
                      label="Categoria" id="Categoria" name="Categoria"
                      value={Categoria} onChange={onChangeCategoria}
                    >
                      {listaCategoria.map((cat, index) => (
                        <MenuItem value={cat.Id} key={cat.Id}>
                          <em>{cat.Nom}</em>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid> :null
                }
                {listaStatus.length!=0 ? 
                <Grid item sx={1}>
                <FormControl className={classes.formSelect}>
                    <InputLabel id="Status">Status</InputLabel>
                    <Select
                      label="Status" id="Status" name="Status"
                      value={Status} onChange={onChangeStatus}
                    >
                      {listaStatus.map((stat, index) => (
                        <MenuItem value={stat.Id} key={stat.Id}>
                          <em>{stat.Nom}</em>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid> :null
                }
            </Grid>
            <Grid container spacing={1}>
                {listaUnidad.length!=0 ? 
                <Grid item sx={6}>
                <FormControl className={classes.formSelectUnidad}>
                    <InputLabel id="Unidad">Unidad</InputLabel>
                    <Select
                      label="Unidad" id="Unidad" name="Unidad"
                      value={Unidad} onChange={onChangeUnidad}
                    >
                      {listaUnidad.map((uni, index) => (
                        <MenuItem value={uni.Id} key={uni.Id}>
                          <em>{uni.Placa+" "+uni.Observ}</em>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid> :null
                }
                {listaElementos.length!=0 ? 
                <Grid item sx={1}>
                <FormControl className={classes.formSelectElemento}>
                    <InputLabel id="Elemento">Elemento</InputLabel>
                    <Select
                      label="Elemento" id="Elemento" name="Elemento"
                      value={Elemento} onChange={onChangeElemento}
                    >
                      {listaElementos.map((ele, index) => (
                        <MenuItem value={ele.Id} key={ele.Id}>
                          <em>{ele.Nombre+" "+ele.Paterno+" "+ele.Materno}</em>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid> :null
                }
            </Grid>
            <Grid container spacing={1}>
                <Grid item>
                <FormControl className={classes.formAnotacion}>
                    <TextField required label="Dirección"
                                  value={Direcc} onChange={onChangeDireccion}id={'Direcc'}/> 
                  </FormControl>
                </Grid>
            </Grid>
            <Box display="flex" flexDirection="column">
            <textarea className={classes.formObs} placeholder="Descripción"
              value={Descr} onChange={onChangeDescripcion} id={'Descr'}
              multiline rows={2} maxRows={4}/>
            <textarea className={classes.formObs} placeholder="Observación"
              value={Observ} onChange={onChangeObservacion} id={'Observ'}
              multiline rows={2} maxRows={4}/>
            </Box>
            </form>
        </Modal>
    )
}